import doctor1 from "../Img/Davit.png";
import doctor2 from "../Img/Armine.png";
import doctor3 from "../Img/Stela.png";
import doctor4 from "../Img/Eva.png";
import doctor5 from "../Img/Mar.png";
import doctor6 from "../Img/Lilia.png";
import doctor7 from "../Img/Irina.png";


export const staffImages = {
    doctor1,
    doctor2,
    doctor3,
    doctor4,
    doctor5,
    doctor6,
    doctor7,
};
